import ActionTypes from '../action-types';
import { onFulfill, onPending, onReject } from '../util';

const initialState = {
  currentTask: {
    task: {},
    hasAudioUrl: false
  },
  isLoading: false,
  error: null
};

export default (state = initialState, action = {}) => {
  const { type, payload, meta } = action;

  switch (type) {
    case onPending(ActionTypes.GET_PENDING_TASKS):
    case onPending(ActionTypes.GET_TASK):
      return {
        ...state,
        isLoading: true
      };

    case onReject(ActionTypes.GET_PENDING_TASKS):
    case onReject(ActionTypes.GET_TASK):
      return {
        ...state,
        isLoading: false
      };
    case onPending(ActionTypes.POLL_CALL_AUDIO_FEEDBACK):
      return {
        ...state,
        currentTask: {
          ...state.currentTask,
          hasAudioUrl: true
        }
      };
    case onFulfill(ActionTypes.POLL_CALL_AUDIO_FEEDBACK):
      return {
        ...state,
        currentTask: {
          ...state.currentTask,
          hasAudioUrl: true
        }
      };
    case onFulfill(ActionTypes.GET_PENDING_TASKS):
      return {
        ...state,
        currentTask: {
          hasAudioUrl: false,
          task: payload.tasks.length > 0 ? payload.tasks[0] : {}
        },
        isLoading: false
      };
    case onFulfill(ActionTypes.GET_TASK):
      return {
        ...state,
        currentTask: {
          hasAudioUrl: false,
          task: {
            ...payload,
            ...meta
          }
        },
        isLoading: false
      };
    case ActionTypes.CLEAR_TASK:
    case onFulfill(ActionTypes.COMPLETE_TASK):
      return {
        ...state,
        currentTask: initialState.currentTask
      };
    default:
      return state;
  }
};
